import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const PlateBarcodeItem = ({ 
  type, plateName, barcodeList, inactiveBarcodesList, handlePlatesChange 
}) => {
  return(
    <Box>
      <FormControl component="fieldset">
        <FormLabel component="legend">{type}</FormLabel>
        <FormGroup aria-label="position" row>
          {
            barcodeList.map((data, index) => (
              <FormControlLabel
                value={data.barcode}
                control={
                  <Checkbox 
                    checked={!inactiveBarcodesList.includes(data.barcode)}
                    onChange={
                      e => handlePlatesChange(
                        e, type.toLowerCase(), data.barcode, plateName
                      )
                    }
                  />
                }
                label={data.barcode}
                labelPlacement="end"
                key={index}
              />
            ))
          }
        </FormGroup>
      </FormControl>
    </Box>
  );
};

PlateBarcodeItem.propTypes = {
  type: PropTypes.string.isRequired,
  barcodeList: PropTypes.array.isRequired,
  inactiveBarcodesList: PropTypes.array.isRequired,
  handlePlatesChange: PropTypes.func.isRequired,
};

export default PlateBarcodeItem;